import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, firstValueFrom, from } from "rxjs";
import { Effort } from "../models/effort";
import { environment } from "../../environments/environment";
import { EffortsService } from "../services/efforts.service";

@Injectable()
export class EffortsResolver  {
    constructor(
        private router: Router,
        private effortService: EffortsService,
        private http: HttpClient)
    {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Effort[]> {
        const p = route.params;
        this.effortService.fetchEfforts();
        return this.effortService.efforts$;
    }
}